var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16602 5.66699C8.16602 5.20699 8.53935 4.83366 8.99935 4.83366C9.45935 4.83366 9.83268 5.20699 9.83268 5.66699C9.83268 6.12699 9.45935 6.50033 8.99935 6.50033C8.53935 6.50033 8.16602 6.12699 8.16602 5.66699ZM8.16602 8.16699C8.16602 7.70699 8.53935 7.33366 8.99935 7.33366C9.45935 7.33366 9.83268 7.70699 9.83268 8.16699V12.3337C9.83268 12.7937 9.45935 13.167 8.99935 13.167C8.53935 13.167 8.16602 12.7937 8.16602 12.3337V8.16699ZM8.99935 15.667C5.32352 15.667 2.33268 12.6762 2.33268 9.00033C2.33268 5.32449 5.32352 2.33366 8.99935 2.33366C12.6752 2.33366 15.666 5.32449 15.666 9.00033C15.666 12.6762 12.6752 15.667 8.99935 15.667ZM8.99935 0.666992C4.39685 0.666992 0.666016 4.39783 0.666016 9.00033C0.666016 13.6028 4.39685 17.3337 8.99935 17.3337C13.601 17.3337 17.3327 13.6028 17.3327 9.00033C17.3327 4.39783 13.601 0.666992 8.99935 0.666992Z",
    fill: "#FE8134"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/infoCircle.9527877b.svg";
export { ForwardRef as ReactComponent };